module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/operator/filter","commonjs2":"rxjs/add/operator/filter","amd":"rxjs/add/operator/filter"}
// module id = 7
// module chunks = 0 1